import { useTranslation } from 'react-i18next';
import { mapRef } from '../map/mapRef';
import { useStore } from '../store';
import { IconLocate } from './icons';

// Persistent "jump to my location" button, stacked below the map-style toggle. Works in every phase:
// while driving it re-attaches the chase camera (and pulses when the user has panned away); otherwise
// it centers the overview camera on the latest fix. Dimmed when there's no fix yet.
export function LocateButton() {
  const { t } = useTranslation();
  const fix = useStore((s) => s.fix);
  const phase = useStore((s) => s.phase);
  const cameraFollowing = useStore((s) => s.cameraFollowing);
  const driving = phase === 'driving' || phase === 'paused';
  const needsRefollow = driving && !cameraFollowing;

  const onClick = () => {
    if (!fix) return;
    if (driving) mapRef.current?.resumeFollow(fix);
    else mapRef.current?.flyToFix(fix);
  };

  return (
    <button
      onClick={onClick}
      disabled={!fix}
      aria-label={t('map.locate')}
      title={t('map.locate')}
      className={`top-safe-stacked-2 pointer-events-auto absolute right-3 flex h-9 w-9 items-center justify-center rounded-full text-white backdrop-blur active:scale-95 disabled:opacity-40 ${
        needsRefollow ? 'bg-emerald-600 ring-2 ring-white/70' : 'bg-black/55'
      }`}
    >
      <IconLocate />
    </button>
  );
}
